import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import withStyles from "@material-ui/styles/withStyles";
import { Grid } from "@material-ui/core";

import styles from "./Login.styles";
import LoginForm from "./LoginForm";

import {
  login,
  selectLoader,
  selectError,
  selectUser,
  refreshSession,
} from "./authenticationSlice";

function Login({ classes }) {
  const loader = useSelector(selectLoader);
  const error = useSelector(selectError);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  let history = useHistory();
  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/dashboard" } };

  useEffect(() => {
    dispatch(refreshSession());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user) {
      history.replace(from);
    }
    // eslint-disable-next-line
  }, [user]);

  const onLoginSubmit = (data) => {
    // console.log('data: %o', data);
    dispatch(login(data.email, data.password));
  };

  return (
    <Grid
      className={classes.root}
      container
      direction="row"
      justify="center"
      alignItems="center"
    >
      <LoginForm
        classes={classes}
        onLoginSubmit={onLoginSubmit}
        loader={loader}
        error={error}
      />
    </Grid>
  );
}

export default withStyles(styles)(Login);
